import styled from 'styled-components';

export const StyledMain = styled.main`
  display: flex;
  padding: 0 16px;
  margin:0 auto;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 100vh;
  max-width: 1200px;
`;